(() => {
  const video=document.getElementById('hero-video');
  if(!video)return;
  const media=video.closest('.hero-media');
  const photo=document.getElementById('hero-photo');
  const trigger=document.querySelector('[data-play-hero]');
  const back=document.querySelector('[data-hero-back]');
  const error=document.querySelector('.hero-video-error');
  const source=video.querySelector('source');
  let active=false;

  function showPhoto(){
    active=false;
    video.pause();
    video.hidden=true;
    photo.hidden=false;
    back.hidden=true;
    error.hidden=true;
    media.dataset.heroState='photo';
  }
  function showError(){
    showPhoto();
    error.hidden=false;
  }
  function playHere(){
    error.hidden=true;
    if(!active && video.readyState>0)video.currentTime=0;
    active=true;
    photo.hidden=true;
    video.hidden=false;
    back.hidden=false;
    media.dataset.heroState='video';
    if(!source.getAttribute('src')||video.error){
      source.src=source.dataset.src;
      video.load();
    }
    if(video.ended)video.currentTime=0;
    video.play().catch(()=>{
      // Keep native controls available if playback needs another gesture.
      if(active&&video.error)showError();
    });
  }
  trigger.addEventListener('click',playHere);
  document.querySelector('[data-hero-retry]').addEventListener('click',playHere);
  back.addEventListener('click',()=>{showPhoto();trigger.focus();});
  video.addEventListener('error',()=>{if(active)showError();});
  source.addEventListener('error',()=>{if(active)showError();});
  // The media source is attached only after the visitor requests the demo.
  new IntersectionObserver(entries=>{
    if(!entries[0].isIntersecting)video.pause();
  },{threshold:0}).observe(media);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();});
  document.querySelectorAll('dialog').forEach(dialog=>{
    new MutationObserver(()=>{if(dialog.open)video.pause();}).observe(dialog,{attributes:true,attributeFilter:['open']});
  });
  showPhoto();
})();
